interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'circular' | 'rectangular';
}

export function Skeleton({
  className = '',
  width,
  height,
  variant = 'rectangular',
}: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={`skeleton skeleton-${variant} ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}

export function BookCardSkeleton() {
  return (
    <div className="book-card skeleton-card" aria-hidden="true">
      <div className="book-cover">
        <Skeleton variant="rectangular" className="skeleton-cover" />
      </div>
      <div className="book-info">
        <Skeleton variant="text" className="skeleton-title" />
        <Skeleton variant="text" className="skeleton-author" width="60%" />
        <Skeleton variant="text" className="skeleton-meta" width="40%" />
      </div>
    </div>
  );
}

export function BookGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="book-grid" aria-label="Loading books...">
      {Array.from({ length: count }).map((_, i) => (
        <BookCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function AuthorCardSkeleton() {
  return (
    <div className="author-card skeleton-card" aria-hidden="true">
      <Skeleton variant="text" className="skeleton-title" />
      <Skeleton variant="text" className="skeleton-meta" width="50%" />
    </div>
  );
}

export function AuthorGridSkeleton({ count = 12 }: { count?: number }) {
  return (
    <div className="authors-grid" aria-label="Loading authors...">
      {Array.from({ length: count }).map((_, i) => (
        <AuthorCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function CollectionCardSkeleton() {
  return (
    <div className="collection-card skeleton-card" aria-hidden="true">
      <div className="collection-card-content">
        <Skeleton variant="text" className="skeleton-title" />
        <Skeleton variant="text" className="skeleton-description" />
        <div className="collection-meta">
          <Skeleton variant="text" width="80px" height="16px" />
          <Skeleton variant="text" width="120px" height="16px" />
        </div>
      </div>
    </div>
  );
}

export function CollectionGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="collections-grid" aria-label="Loading collections...">
      {Array.from({ length: count }).map((_, i) => (
        <CollectionCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function PageHeaderSkeleton() {
  return (
    <header className="page-header skeleton-header" aria-hidden="true">
      <Skeleton variant="text" width="200px" height="32px" />
      <Skeleton variant="text" width="150px" height="20px" />
    </header>
  );
}
